import { formatCents } from 'betterplace-utils'
import type { GetErrorMap } from '@/helpers/operations'
import { getHHmmssTimestampFromSeconds } from '@/helpers/utils'
import { getTranslatorWithFallback } from '@/i18n'

const getDonationFormErrorMap: GetErrorMap = (t_, locale) => {
  const t = getTranslatorWithFallback(t_)
  return (issue) => {
    try {
      if (issue.path && (issue.path.includes('_captcha_complete') || issue.path.includes('captcha_solution'))) {
        return t('errors.messages.invalid_captcha')
      }
      if (issue.path && issue.path.includes('amount_cents')) {
        if (issue.code === 'too_small') {
          return t('donate.errors.greater_than')
        }
        if (issue.code === 'too_big') {
          return t('donate.errors.exceeds_platform_limit')
        }
      }
      // This is not showing up in the form. Not even on staging at the moment
      // also logs an error for a missing translation key
      if (issue.path && issue.path.includes('codonation_cents')) {
        if (issue.code === 'too_big') {
          return t('errors.messages.number.too_big_inclusive', {
            constraint: formatCents(locale, issue.maximum as number),
          })
        }
      }
      if (issue.path && issue.path.includes('video_start_time')) {
        if (issue.code === 'too_big') {
          return t('errors.messages.number.too_big', {
            constraint: getHHmmssTimestampFromSeconds(issue.maximum as number),
          })
        }
      }
      if (issue.path && issue.path.includes('voting_option_id')) {
        if (issue.code === 'invalid_type') {
          return t('donate.errors.voting_missing')
        }
      }
      if (issue.code === 'too_big' && issue.origin === 'string') {
        return t('donate.errors.too_long')
      }
      if (
        issue.code === 'invalid_format' &&
        issue.format === 'email' &&
        issue.path?.includes('email') &&
        !issue.input?.length
      ) {
        return t('errors.messages.required')
      }
      return
    } catch (e) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      console.error('Error localising validation', (e as any).message)
      return
    }
  }
}

export default getDonationFormErrorMap
